export default __webpack_public_path__ + "static/media/330_private01-it-web.92bf3a78.png";